<template>
  <div class="header_holder isLanding">
    <div class="navbar navbar-expand-sm p-0 fixed_top" role="navigation" :class="{ 'bottom_shadow': position != 'top'}">
      <div class="row m-0 w-100">
        <div class="col-12">
          <transition name="slide">
            <div v-if="isNavOpen" class="mobile_menu">
              <div class="row full_height justify-content-center align-items-center">
                <div class="col-8">
                  <div class="row m-0">
                    <div class="col-12 text-center mb-3">
                      <router-link @click.native="toggleNavbar" :to="`/${shopId}/store`" class="nav-link">
                        Shop
                      </router-link>
                    </div>
                    <div class="col-12 text-center mb-3" v-if="isLoggedIn">
                      <router-link @click.native="toggleNavbar" to="/orders" class="nav-link">
                        Orders
                      </router-link>
                    </div>
                    <div class="col-12 text-center mb-3">
                      <div v-if="!isLoggedIn" class="li-pointer nav-item">
                        <a @click="login" class="nav-link">Login</a>
                      </div>
                      <div v-if="isLoggedIn" class="li-pointer nav-item">
                        <a @click="logoutAndClose" class="nav-link">Logout {{ userEmail }}</a>
                      </div>
                    </div>
                    <div class="col-12 text-center mb-3" v-if="!isLoggedIn">
                      <div class="li-pointer nav-item">
                        <a @click="register" class="nav-link">Register</a>
                      </div>
                    </div>
                    <div class="col-12 text-center mb-3">
                      <button class="btn btn-outline" @click="createStore">Create your own store</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
          <div class="row m-0 align-items-center justify-content-center h-100 w-100">
            <div class="col-8 col-sm-7 col-md-11 p-0 pl-md-3">
              <div class="row m-0 justify-content-center">
                <div class="col-12 p-0 pl-md-3">
                  <div class="row m-0 justify-content-center align-items-center ">
                    <div class="col-12 col-md-auto offset-md-1 p-0 px-md-3 site_name d-md-none d-lg-flex">
                      <img
                        src="logo.png"
                        class="logo img-fluid d-md-none"
                      />
                      <span class="ml-2 ml-md-0 d-none d-md-flex">Nicarela</span>
                    </div>
                    <div class="col d-none d-md-block p-0">
                      <div class="row m-0 justify-content-end align-items-center">
                        <div class="col-auto p-0 cursor">
                          <div class="row m-0 align-items-center">
                            <div class="col-auto p-0">
                               <ios-pin-icon />
                            </div>
                            <div class="col p-0">
                              <vue-google-autocomplete
                                id="deliveryAddress"
                                classname="form-control"
                                placeholder="Deliver to"
                                country="za"
                                v-on:placechanged="getAddressData"
                                v-model="address"
                                :onlyStreet="true">
                              </vue-google-autocomplete>
                            </div>
                          </div>
                        </div>
                        <div class="col-auto p-0 cursor">
                          <div v-if="!isLoggedIn" @click="login" class="pb-1">
                            Login
                          </div>
                          <profile-menu :user="currentUser" v-else></profile-menu>
                        </div>
                        <div class="col-auto pr-0 cursor">
                          <div @click="createStore" class="pb-1">
                            <button class="btn btn-outline">Create your own store</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col p-0 d-md-none">
              <div class="row m-0 justify-content-end align-items-center">
                <div class="col-auto p-0 text-right">
                  <div class="row m-0 h-100 align-items-center justify-content-end">
                    <div class="cart_mobile">
                      <div @click="toggleNavbar" class="above_all cursor text-center">
                        <ios-menu-icon v-if="isNavOpen" class="ninety_degree" />
                        <ios-menu-icon v-else/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row m-0 d-md-none address navbar">
      <div class="col-9 p-0">
        <div class="row m-0 align-items-center">
          <div class="col-auto p-0">
            <ios-pin-icon />
          </div>
          <div class="col p-0">
            <vue-google-autocomplete
              id="deliveryAddressMobile"
              classname="form-control"
              placeholder="Deliver to"
              v-model="address"
              v-on:placechanged="getAddressData"
              country="za"
              :onlyStreet="true">
            </vue-google-autocomplete>
          </div>
        </div>
      </div>
    </div>
    <div class="row mx-0 align-items-center shop_details_holder">
      <div class="col-2 logo_holder d-none d-md-block" id="logo">
        <div class="small-logo transparent h-100">
          <img
            src="logo.png"
            class="img-fluid"
            @load="onImgLoad"
          />
        </div>
        <div class="small-logo absolute cursor" :class="{'fixed_logo': isScrolled}">
          <img
            src="logo.png"
            class="img-fluid"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapActions, mapGetters
} from 'vuex'
export default {
  components: {
    'profile-menu': () => import('@/components/common/UserMenuItem.vue'),
    VueGoogleAutocomplete: () => import('@/components/common/VueGoogleAutocomplete.vue')
  },
  props: {
    position: {
      type: String,
      required: false,
      default: 'top'
    },
    isLanding: {
      type: Boolean,
      required: false,
      default: false
    },
    currentPage: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      isNavOpen: false,
      hasImage: true,
      isScrolled: false,
      logoHeight: ''
    }
  },
  beforeMount () {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  computed: {
    ...mapGetters(['isLoggedIn', 'cartValue', 'currentUser', 'cartItemList', 'shopDetails', 'shopId']),
    numItems () {
      return this.cartItemList.reduce((total, item) => {
        total += item.quantity
        return total
      }, 0)
    },
    address () {
      if (this.currentUser && this.currentUser.deliveryAddress) {
        if (typeof this.currentUser.deliveryAddress.street_number !== 'undefined') {
          return this.currentUser.deliveryAddress.street_number + ' ' + this.currentUser.deliveryAddress.route
        }
        return this.currentUser.deliveryAddress.route + ', ' + this.currentUser.deliveryAddress.locality
      } else {
        return ''
      }
    },
    userEmail () {
      return this.isLoggedIn ? this.currentUser.email : ''
    },
    notHome () {
      return this.$route.path !== '/'
    }
  },
  methods: {
    ...mapActions(['logout', 'saveDeliveryAddress']),
    getAddressData (addressData, placeResultData, id) {
      this.saveDeliveryAddress(addressData)
    },
    toggleNavbar () {
      this.isNavOpen = !this.isNavOpen
    },
    logoutAndClose () {
      this.isNavOpen = false
      this.logout()
    },
    login () {
      this.$emit('goToLogin')
      this.isNavOpen = false
    },
    createStore () {
      window.open('https://admin.thehoods.app/', '_blank')
    },
    toHoods () {
      window.location = 'https://thehoods.app/'
    },
    register () {
      this.$emit('goToRegister')
      this.isNavOpen = false
    },
    onImgLoad () {
      var logo = document.getElementById('logo')
      if (logo) {
        this.logoHeight = (logo.offsetTop)
      }
    },
    handleScroll () {
      if (window.pageYOffset > this.logoHeight) {
        this.isScrolled = true
      } else {
        this.isScrolled = false
      }
    }
  }
}
</script>

<style scoped>
.to_hoods {
  position: absolute;
  left: 0;
  z-index: 9999;
}
.to_hoods .ion {
  font-size: 50px;
  font-weight: bold;
}
.header_holder {
  height: calc(30vh + 80px + 54px);
  padding-top: 80px;
  background-color: var(--light-color);
}
.header_holder.is_checkout {
  height: 80px;
}
.is_cart {
  display: none;
}
.isLanding {
  height: 134px;
}
.bg_gradient {
  /* background-image: -moz-linear-gradient(0deg, #46dbf9 0%, #204be3 100%);
  background-image: -webkit-linear-gradient(0deg, #46dbf9 0%, #204be3 100%);
  background-image: -ms-linear-gradient(0deg, #46dbf9 0%, #204be3 100%);
  background-image: -o-linear-gradient(0deg, #46dbf9 0%, #204be3 100%);
  background: linear-gradient( 0deg, #46dbf9 0%, #204be3 100%); */
  /* background: linear-gradient( rgba(255,255,255,1) 0%, var(--dark-color-off) 98%, var(--dark-color) 100%); */
  background-color: rgba(70, 219, 249, 1) !important;
}
.dark-mode .header_holder {
  background-color: var(--dark-color);
}
.navbar {
  height: 80px;
  color: var(--dark-color);
  background-color: var(--light-color-08);
}
.address {
  height: max-content;
}
.fixed_top {
  position: fixed;
  top: 0;
  z-index: 99;
  width: 100vw;
  /* background-color: transparent; */
}
.dark-mode .navbar {
  color: var(--light-color);
  background-color: var(--dark-color-08);
}
.bottom_shadow {
  -webkit-box-shadow: 0 0 8px 1px var(--dark-color-03);
  box-shadow: 0 0 8px 1px var(--dark-color-03);
  background-color: var(--light-color);
}
.dark-mode .bottom_shadow {
  background-color: var(--dark-color);
  border-bottom: 1px solid var(--dark-color);
  background-color: var(--dark-color-off);
}
.bg_image {
  object-fit: cover;
  width: 100%;
  height: 100%;
  position: absolute;
  height: calc(40vh + 54px);
}
.shop_details {
  background-color: var(--light-color);
}
.dark-mode .shop_details {
  background-color: var(--dark-color);
}
.li-pointer {
  cursor: pointer;
}
.li-pointer:hover {
  cursor: pointer;
}
.ion {
  font-size: 30px;
}
.mobile_menu {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  z-index: 999;
  background-color: var(--light-color-09);
  color: var(--dark-color);
}
.dark-mode .mobile_menu {
  background-color: var(--dark-color-09);
  color: var(--light-color);
}
.mobile_menu .nav-link {
  display: block;
  padding: 0;
}
.close_icon {
  position: absolute;
  left: 17px;
  top: 17px;
  width: 25vw;
  text-align: left;
}
.slide-enter-active {
  transition: all 0.5s ease;
}
.slide-leave-active {
  transition: all 0.5s ease;
}
.slide-enter {
  transform: translateX(100%);
  opacity: 1;
}
.slide-leave-to {
  transform: translateX(100%);
  opacity: 1;
}
.full_height {
  height: 100vh;
}
.logo {
  max-width: 100%;
  height: calc(80px - 2rem);
  top: 0.1rem;
  max-width: 100%;
  max-height: calc(80px - 1rem);
}
.above_all {
  z-index: 999;
  position: relative;
}
.ninety_degree {
  transform: rotate(90deg);
}
.cart_mobile {
  width: 44px;
  height: 44px;
  text-align: center;
  border-radius: 50%;
  padding: 7px;
}
.cartValue {
  background-color: var(--dark-color);
  color: var(--light-color);
  padding: 12px;
}
.dark-mode .cartValue {
  background-color: var(--light-color);
  color: var(--dark-color);
}
.cartValue .ion {
  font-size: 20px;
}
.mobilebadge {
  position: absolute;
  right: 0px;
  top: 0px;
  font-size: 9px;
  width: 20px;
  height: 20px;
  background-color: var(--dark-color);
  background-color: var(--hoods-color);
  color: var(--light-color);
  border-radius: 50%;
  text-align: center;
  line-height: 1.2;
}
.dark-mode .mobilebadge {
  color: var(--dark-color);
  background-color: var(--light-color);
  background-color: var(--hoods-color);
}
.site_name {
  font-size: 1.4rem;
}
.form-control {
  background: transparent !important;
  border: none;
  border-bottom: 1px solid transparent;
  padding-top: 0;
}
.form-control:focus:valid {
  border-bottom: 1px solid;
}
.form-control:valid {
  border-bottom: 1px solid transparent;
}
.shop_details_holder {
  height: calc(100% - 54px);
}
.truncate {
  word-wrap: break-word;
  overflow-y: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  height: 1;
}
@media (min-width: 768px) {
  .header_holder {
    height: 30vh;
    background-color: var(--light-color);
    padding-top: 0;
  }
  .isLanding {
    height: 50px;
  }
  .shop_details_holder {
    height: 100%;
  }
  .bg_image {
    height: 40vh;
  }
  .dark-mode .header_holder {
    background-color: var(--dark-color);
  }
  .header_holder.is_checkout {
    height: 30vh;
  }
  .is_cart {
    display: flex;
  }
  .site_name {
    font-size: 1.7rem;
    font-weight: 500;
  }
  .navbar {
    /* background-color: transparent; */
    height: 50px;
  }
  .bottom_shadow {
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  .dark-mode .bottom_shadow {
    /* background-color: transparent; */
    border-bottom: none;
  }
  .logo_holder {
    position: relative;
    padding-left: 10px;
  }
  .absolute {
    position: absolute;
    left: 10px;
    top: 20px;
    z-index: 99;
  }
  .transparent {
    opacity: 0;
  }
  .fixed_logo {
    position: fixed;
    left: 10px;
    top: 10px;
    z-index: 99;
    max-width: 16.6666666667%;
  }
  .small-logo {
    width: calc((8.33vw / 2) + 8.3vw + 1rem);
    animation: shrink;
    animation-duration: 1s;
    animation-timing-function: ease;
  }
  .big-logo {
    text-align: right;
    width: calc(16.7vw + 1rem + (8.3vw /  2));
    animation: grow;
    animation-duration: 1s;
    animation-timing-function: ease;
  }
  .loading {
    animation-duration: 0s;
  }
  @keyframes grow {
    0% {
      width: calc((8.33vw / 2) + 8.3vw + 2rem);
      top: 0.5rem;
      left: 0.5rem;
    }
    100% {
      width: calc(16.7vw + 1rem + (8.3vw /  2));
      top: 0.5rem;
      left: 0.5rem;
    }
  }
  @keyframes shrink {
    0% {
      width: calc(16.7vw + 1rem + (8.3vw /  2));
      top: 0.5rem;
      left: 0.5rem;
    }
    100% {
      width: calc((8.33vw / 2) + 8.3vw + 2rem);
      top: 0.5rem;
      left: 0.5rem;
    }
  }
}
</style>
